const APPEAL_ANSWER = 'appealReview/APPEAL_ANSWER';
const ACCEPT_ANSWER = 'appealReview/ACCEPT_ANSWER';
const SET_APPEAL_REASON = 'appealReview/SET_APPEAL_REASON';
const SET_APPEAL_RESOLUTION = 'appealReview/SET_APPEAL_RESOLUTION';
const SET_APPEAL_REASONS = 'appealReview/SET_APPEAL_REASONS';
const SET_APPEAL_RESOLUTIONS = 'appealReview/SET_APPEAL_RESOLUTIONS';
const CLEAR = 'appealReview/CLEAR';
const START_APPEAL = 'appealReview/START_APPEAL';
const CANCEL_APPEAL = 'appealReview/CANCEL_APPEAL';
const APPEAL_SUBMITTED = 'appealReview/APPEAL_SUBMITTED';

export const appealAnswer = id => ({
  type: APPEAL_ANSWER,
  id,
});

export const acceptAnswer = id => ({
  type: ACCEPT_ANSWER,
  id,
});

export const setAppealReason = (id, reason) => ({
  type: SET_APPEAL_REASON,
  id,
  reason,
});

export const setResolution = (id, resolution) => ({
  type: SET_APPEAL_RESOLUTION,
  id,
  resolution,
});

export const clearAppeal = () => ({
  type: CLEAR,
});

const setAppealReasons = (reasons, appealId, createdAt, employee) => ({
  type: SET_APPEAL_REASONS,
  reasons,
  appealId,
  createdAt,
  employee,
});

const setAppealResolutions = (resolutions, createdAt, employee) => ({
  type: SET_APPEAL_RESOLUTIONS,
  resolutions,
  createdAt,
  employee,
});

export const startAppeal = () => ({
  type: START_APPEAL,
});

export const cancelAppeal = () => ({
  type: CANCEL_APPEAL,
});

export const appealSubmitted = () => ({
  type: APPEAL_SUBMITTED,
});

const formatReasons = reasons => {
  const formatedReasons = {};
  reasons.forEach(reason => {
    formatedReasons[reason.qaAnswer.id] = reason.note;
  });
  return formatedReasons;
};

export const pupulateAppealReasons =
  (reasons, appealId, createdAt, employee) => dispatch => {
    const formatedReasons = formatReasons(reasons);
    dispatch(setAppealReasons(formatedReasons, appealId, createdAt, employee));
  };

export const pupulateAppealResolutions =
  (resolution = {}) =>
  dispatch => {
    const { reasons, employee, createdAt } = resolution;
    const formatedResolutions = formatReasons(reasons);
    dispatch(setAppealResolutions(formatedResolutions, createdAt, employee));
  };

const initialState = {
  appealId: null,
  enableActions: false,
  reasons: {},
  resolutions: {},
  employee: {},
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case APPEAL_ANSWER: {
      return {
        ...state,
        reasons: {
          ...state.reasons,
          [action.id]: '',
        },
      };
    }
    case ACCEPT_ANSWER: {
      const { [action.id]: match, ...reasons } = state.reasons;
      return {
        ...state,
        reasons,
      };
    }
    case SET_APPEAL_REASON: {
      return {
        ...state,
        reasons: {
          ...state.reasons,
          [action.id]: action.reason,
        },
      };
    }
    case SET_APPEAL_REASONS: {
      return {
        ...state,
        reasons: {
          createdAt: action.createdAt,
          ...action.reasons,
        },
        appealId: action.appealId,
        employee: action.employee.profile,
      };
    }
    case SET_APPEAL_RESOLUTION: {
      return {
        ...state,
        resolutions: {
          ...state.resolutions,
          [action.id]: action.resolution,
        },
      };
    }
    case SET_APPEAL_RESOLUTIONS: {
      return {
        ...state,
        resolutions: {
          createdAt: action.createdAt,
          employee: action.employee.profile,
          ...action.resolutions,
        },
      };
    }
    case CLEAR: {
      return {
        ...state,
        appealId: null,
        enableActions: false,
        reasons: {},
        resolutions: {},
      };
    }
    case START_APPEAL: {
      return {
        ...state,
        enableActions: true,
      };
    }
    case CANCEL_APPEAL: {
      return {
        ...state,
        enableActions: false,
        reasons: {},
      };
    }
    case APPEAL_SUBMITTED: {
      return {
        ...state,
        enableActions: false,
      };
    }
    default: {
      return state;
    }
  }
};
